import React from "react";
import { useDropzone } from "react-dropzone";
import { MdCloudUpload, MdCheckCircle } from "react-icons/md";

const FileDropzone = ({ file, onFileSelect, isLoading }) => {
  const onDrop = React.useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        onFileSelect(acceptedFiles[0]);
      }
    },
    [onFileSelect]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      "text/csv": [".csv", ".txt"],
    },
  });

  return (
    <div
      {...getRootProps()}
      className={`w-full border-2 border-dashed hover:border-emerald-700 hover:bg-emerald-50 hover:text-emerald-700 rounded-xl p-8 text-center cursor-pointer transition-colors duration-200 mb-4
      ${
        isDragActive
          ? "border-emerald-500 bg-emerald-50"
          : "border-gray-300 bg-white"
      }`}
    >
      <input {...getInputProps()} />
      {file ? (
        <div className="flex flex-col items-center justify-center">
          <MdCheckCircle className="text-5xl text-emerald-600 mb-2" />
          <p className="text-emerald-700 font-medium">Arquivo selecionado</p>
          <p className="text-gray-600 text-sm mt-1">{file.name}</p>
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center">
          <MdCloudUpload className="text-5xl text-gray-400 mb-2" />
          <p className="text-gray-600 font-medium">
            Arraste e solte um arquivo aqui
          </p>
          <p className="text-gray-500 text-sm mt-1">
            ou clique para selecionar
          </p>
          <p className="text-gray-400 text-xs mt-3">
            Formatos aceitos: .csv, .txt
          </p>
        </div>
      )}
    </div>
  );
};

export default FileDropzone;
